


export default {
  props: {
    images: {
      type: Array
    }
  },
  data () {
    return {
      activeItem: 0
    }
  },
  methods: {
    navigateTo (index) {
      this.activeItem = index
    }
  }
}
